export const isTestDomain =
  window.location.hostname.includes("ner-front.") || window.location.hostname.includes("testlm.");